export const REQUEST_SHIPPING_ADVISORY_DATA = 'REQUEST_SHIPPING_ADVISORY_DATA';
export const RECEIVE_SHIPPING_ADVISORY_DATA = 'RECEIVE_SHIPPING_ADVISORY_DATA';

export const receiveShippingAdvisoryData = (payload) => ({
  type: RECEIVE_SHIPPING_ADVISORY_DATA,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/shippingAdvisoryActions.js